import { render } from "./UpdateActions.vue?vue&type=template&id=141d5d98&ts=true"
import script from "./UpdateActions.vue?vue&type=script&lang=ts"
export * from "./UpdateActions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__